<template>
<div class="prelative">
    <preloader :display="loading" class="preloader" />
    <div v-if="!loading" v-html="html" />
</div>
</template>
<script>

import SAMMixins from 'mixins/subscription/SAMMixins'
import WidgetStore from 'mixins/sellsyaccountmanager/store/widgetStoreMixins'
import WidgetMixins from 'mixins/sellsyaccountmanager/widgetMixins'
import Preloader from "vcomponents/utilities/Preloader.vue";

export default {
    mixins: [SAMMixins, WidgetStore, WidgetMixins],
    props: {
        thirdid: {
            type: [Number, String],
            required: true
        }
    },
    data(){
        return {
           html: '',
           loading: true
        }
    },

    created(){
        this.fetchHtml().then(() => SellsyAdmin.entittyTips())
    },

    methods: {
        fetchHtml(){
            return new Promise((resolve, reject) => {
                this.$ajax.get(`/rest/sellsy-account-manager/third-addon/${this.thirdid}`, {},
                    (response) => {
                        this.html = response.html.replace('%staffConnection%', '')
                        this.loading = false
                        resolve()
                    },
                    (error) => {
                        reject(error)
                    }
                );
            })

        }
    },
    components: {
        Preloader,
    }
}
</script>